import Vue from 'vue'

const luReportedType = {
  state: {
    luReportedType: [],
    selectedLuReportedType: {},
  },

  getters: {
    luReportedType(state) {
      return state.luReportedType
    },
    selectedLuReportedType(state) {
      return state.selectedLuReportedType
    },
  },

  mutations: {
    luReportedType(state, payload) {
      state.luReportedType = payload
    },
    selectedLuReportedType(state, payload) {
      state.selectedLuReportedType = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedLuReportedType(context, payload) {
      context.commit('selectedLuReportedType', payload)
    },
    loadLuReportedType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuReportedType'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luReportedType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedLuReportedType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuReportedType/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuReportedType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateLuReportedType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuReportedType/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'reported type updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuReportedType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createLuReportedType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuReportedType`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'reported type created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuReportedType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveLuReportedType(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuReportedType', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuReportedType', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuReportedType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuReportedType/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'reported type deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuReportedType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default luReportedType
